import React, { useState } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import css from './FieldTooltip.module.css';

const FieldTooltip = ({ 
  tooltipId, 
  tooltipText, 
  className, 
  rootClassName,
  iconClassName,
  position = 'top' // 'top', 'bottom', 'left', 'right'
}) => {
  const [isVisible, setIsVisible] = useState(false);

  const handleMouseEnter = () => setIsVisible(true);
  const handleMouseLeave = () => setIsVisible(false);

  const classes = classNames(rootClassName || css.root, className);
  const iconClasses = classNames(css.icon, iconClassName);
  const tooltipClasses = classNames(css.tooltip, css[`tooltip${position.charAt(0).toUpperCase() + position.slice(1)}`]);

  return (
    <div className={classes}>
      <span
        className={iconClasses}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        role="button"
        tabIndex={0}
        aria-label="Help information"
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setIsVisible(!isVisible);
          }
        }}
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="10" cy="10" r="9" stroke="currentColor" strokeWidth="1.5" fill="currentColor"/>
          <path d="M7.5 7.5C7.5 5.5 9 4 11 4C13 4 14.5 5.5 14.5 7.5C14.5 9.5 13 11 11 11V12.5" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
          <circle cx="11" cy="15" r="0.75" fill="white"/>
        </svg>
      </span>
      {isVisible && (
        <div className={tooltipClasses}>
          {tooltipId ? (
            <FormattedMessage id={tooltipId} />
          ) : (
            tooltipText
          )}
        </div>
      )}
    </div>
  );
};

export default FieldTooltip; 